// src/components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");

  if (!token) {
    // kalau tidak ada token arahkan ke login
    return <Navigate to="/" replace />;
  }

  return children;
}
